// extracted by mini-css-extract-plugin
export default {"component":"GameCardsLine__component--slots-dPHNY","line":"GameCardsLine__line--slots-Toa41","titled":"GameCardsLine__titled--slots-HRtv6"};